const getSelectedHotelItinerary = (itinerary, hotelItineraries) => {
  if (!itinerary || !hotelItineraries || !(Object.keys(hotelItineraries).length > 0)) return false;

  const compareHotels = (hotel1, hotel2) =>
    hotel1.hotelKey === hotel2.hotelKey &&
    hotel1.startDateTime === hotel2.startDateTime &&
    hotel1.endDateTime === hotel2.endDateTime;

  const itemsToCompare = Array.isArray(hotelItineraries) ? hotelItineraries : [hotelItineraries];

  const found = itemsToCompare.find((item) => compareHotels(itinerary, item));
  return found || false;
};

export default getSelectedHotelItinerary;
